import { roleFieldName } from 'helpers/fields/external-team-members-fields/custom-fields';
import { useExternalTeamMemberFieldsAsFilterableField } from 'helpers/fields/external-team-members-fields/fields';

export const useExternalTeamMemberRoleField = () => {
  const { fields: userFields, loading: isUserFieldsLoading } =
    useExternalTeamMemberFieldsAsFilterableField();

  return {
    field: userFields.find((field) => field.fieldName === roleFieldName),
    loading: isUserFieldsLoading,
  };
};
